import React, { useState, useEffect, useRef } from "react";
import * as FaIcons from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import "./Navbar.css";
import { IconContext } from "react-icons";
import Auth from "./Auth";
import { signOut } from "firebase/auth";
import { auth } from "../config/firebase";
import { useTasks } from "../context/TaskContext";

function Navbar() {
  const { user, userDisplayName } = useTasks();
  const [sidebar, setSidebar] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const sidebarRef = useRef(null); // initialize sidebar ref
  const authRef = useRef(null); // initialize auth modal ref
  const closeAuthModal = () => setShowAuth(false);

  const showSidebar = () => setSidebar(!sidebar);
  const handleShowAuth = () => setShowAuth((prev) => !prev);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        console.log("User signed out");
      })
      .catch((error) => {
        // An error occurred.
        console.error("Error signing out: ", error);
      });
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        sidebar &&
        sidebarRef.current &&
        !sidebarRef.current.contains(e.target)
      ) {
        setSidebar(false); // close sidebar if click was outside sidebar
      }

      if (showAuth && authRef.current && !authRef.current.contains(e.target)) {
        setShowAuth(false); // close auth modal if click was outside auth modal
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [sidebar, showAuth]); // added sidebar in the array of dependencies

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars
              onClick={showSidebar}
              style={{ marginLeft: "10px" }}
            />
          </Link>
          <h2 className="navbar-logo">Obey the Bell</h2>
          {user ? (
            <div className="navbar-user">
              <span className="pill">{userDisplayName || "Signed in"}</span>
              <button onClick={handleLogout} className="auth-button">
                Sign Out
              </button>
            </div>
          ) : (
            <button onClick={handleShowAuth} className="auth-button">
              Sign In
            </button>
          )}

          <nav
            ref={authRef}
            className={showAuth ? "auth-modal show" : "auth-modal"}
          >
            <Auth closeAuthModal={closeAuthModal} />
          </nav>
        </div>
        <nav
          ref={sidebarRef}
          className={sidebar ? "nav-menu active" : "nav-menu"}
        >
          <ul className="nav-menu-items">
            {SidebarData.map((item, index) => (
              <li key={index} className={item.cName} onClick={showSidebar}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `nav-link${isActive ? " nav-link--active" : ""}`
                  }
                >
                  {item.icon}
                  <span>{item.title}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
